import { AiOutlinePoweroff } from "react-icons/ai";
import { FiChevronRight } from "react-icons/fi";
import { MdOutlineDashboard, MdStarOutline } from "react-icons/md";
import { RiParentLine, RiQuestionnaireLine } from "react-icons/ri";
import { GoBook } from "react-icons/go";
import { TbMoodKid } from "react-icons/tb";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "../../axios";
import Swal from "sweetalert2";

export function NavItems() {
    const isAdmin = localStorage.getItem('isAdmin');
    const navigate =  useNavigate();
    const handleLogout = ()=>{
        axios.post('/logout', {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`
            }
        })
        .then((response) => {
            if(response.status === 200) {
                localStorage.clear();
                Swal.fire({
                    icon: 'info',
                    title: 'Logging out...',
                    showConfirmButton: false,
                    timer: 1500,
                    padding: '2em',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.dismiss === Swal.DismissReason.timer) {
                        navigate('/login');
                    }
                });
            } else {
                toast.warn('No response from server');
            }
        })
        .catch((error) => {
            toast.error('Something went wrong');
            console.log(error);
        })
    }
    const nav = isAdmin == 0 || isAdmin === 'undefined' ? (
        [
            {
                id: 1,
                link: '/',
                icon: <MdOutlineDashboard className='menu-icon' />,
                title: 'Dashboard',
                adminOnly: true
            },
            {
                id: 3,
                link: '/activities',
                icon: <MdStarOutline className='menu-icon' />,
                title: 'Activities',
                adminOnly: true
            },
            {
                id: 4,
                link: '/bookings',
                icon: <GoBook className='menu-icon' />,
                title: 'Bookings',
                adminOnly: true
            },
            {
                id: 2,
                link: '/children',
                icon: <TbMoodKid className='menu-icon' />,
                title: 'Children',
                adminOnly: true
            },
            {
                id: 5,
                link: '/faqs',
                icon: <RiQuestionnaireLine className='menu-icon' />,
                title: 'FAQs',
                adminOnly: true
            },
            {
                id: 6,
                link: '/logout',
                icon: <AiOutlinePoweroff className='menu-icon' />,
                title: 'Logout',
                onClick: () =>{handleLogout()}
            }
        ]
    ) : (
        [
            {
                id: 1,
                link: '/',
                icon: <MdOutlineDashboard className='menu-icon' />,
                title: 'Dashboard',
                adminOnly: true
            },
            {
                id: 4,
                link: '/activities',
                icon: <MdStarOutline className='menu-icon' />,
                title: 'Activities',
                adminOnly: true
            },
            {
                id: 5,
                link: '/bookings',
                icon: <GoBook className='menu-icon' />,
                title: 'Bookings',
                adminOnly: true
            },
            {
                id: 2,
                link: '/children',
                icon: <TbMoodKid className='menu-icon' />,
                title: 'Children',
                adminOnly: true
            },
            {
                id: 3,
                link: '/parents',
                icon: <RiParentLine className='menu-icon' />,
                title: 'Parents',
                adminOnly: true
            },
            {
                id: 6,
                link: '/faqs',
                icon: <RiQuestionnaireLine className='menu-icon' />,
                title: 'FAQs',
                adminOnly: true
            },
            {
                id: 7,
                link: '/logout',
                icon: <AiOutlinePoweroff className='menu-icon' />,
                title: 'Logout',
                onClick: () =>{handleLogout()}
            }
        ]
    );

    return (
        <>
            {
                nav.map((navitem)=>{
                    if(navitem.onClick!==undefined){
                        return(
                            <div key={navitem.id} className='menu-item link corner-radius py-3 px-3 d-flex justify-content-between align-items-center' style={{cursor:'pointer'}} onClick={()=>navitem.onClick()}>
                                <div>{navitem.icon} {navitem.title}</div>
                                <FiChevronRight className='menu-arrow' />
                            </div>
                        )
                    } else{
                        return(
                            <NavLink key={navitem.id} to={navitem.link} className='menu-item link corner-radius py-3 px-3 d-flex justify-content-between align-items-center' >
                                <div>{navitem.icon} {navitem.title}</div>
                                <FiChevronRight className='menu-arrow' />
                            </NavLink>
                        )
                    }
                })
            }
        </>
    )
}